import { render, staticRenderFns } from "./sectionModal.vue?vue&type=template&id=77e88550&"
import script from "./sectionModal.vue?vue&type=script&lang=js&"
export * from "./sectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports